import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { "element-loading-text": "正在加载数据，请稍候" }
const _hoisted_2 = { style: {"text-align":"center"} }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 提 交 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 取 消 ")

import { onMounted, reactive, ref, unref } from 'vue';
import { FormRules, ElForm, ElMessage } from 'element-plus';
import { useUser } from '@/store/user.store';
import { ContractTransferApi } from '@/apis/contract/contract.api';


export default /*#__PURE__*/_defineComponent({
  emits: ['refresh'],
  setup(__props, { expose, emit: $emits }) {


const userStore = useUser();

const elFormRef = ref<ComponentRef<typeof ElForm>>();
const state = reactive({
	show: false,
	loading: false,
	loadUsers: false,
	title: '审批移交',
	detail: {} as any,
	userList: [] as any[],
	rules: {
		to_emp_no: [{ required: true, message: '移交用户未选择', trigger: 'blur' }],
		remark: [{ required: true, message: '审核批示不能为空', trigger: 'blur' }],
	} as FormRules,
});

const schema = ref<any>({
	id: '',
	revision: '',
	remark: '',
});

const actions = {
	/* 审批通过 */
	save: () => {
		unref(elFormRef)?.validate(async (isValid: boolean) => {
			if (!isValid) return;

			state.loading = true;

			const formData = unref(schema);
			const { succeeded, errors } = await ContractTransferApi(formData);

			if (!succeeded) {
				ElMessage.error(errors);
			} else {
				ElMessage.success('提交审批成功。');

				$emits('refresh', succeeded);
				state.show = false;
			}

			state.loading = false;
		});
	},
};

/* 打开对话框 */
const showDialog = (contract: any) => {
	schema.value = {
		id: contract.contract_id,
		revision: contract.revision,
	};

	state.detail = contract;
	state.show = true;
};

expose({ showDialog });

onMounted(() => {
	state.userList = userStore.getSelectList();
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_select_v2 = _resolveComponent("el-select-v2")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: "同意批核",
    modelValue: _unref(state).show,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(state).show) = $event)),
    width: "520"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_button, {
          size: "small",
          type: "primary",
          disabled: _unref(state).loading,
          onClick: actions.save
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["disabled", "onClick"]),
        _createVNode(_component_el_button, {
          size: "small",
          type: "info",
          disabled: _unref(state).loading,
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(state).show = false))
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(ElForm), {
          ref_key: "elFormRef",
          ref: elFormRef,
          model: schema.value,
          "label-position": "top",
          rules: _unref(state).rules,
          size: "small"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "合同编号" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(state).detail.contract_no,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).detail.contract_no) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "合同名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(state).detail.contract_name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).detail.contract_name) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "移交用户",
              prop: "to_emp_no"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select_v2, {
                  style: {"width":"480px"},
                  modelValue: schema.value.to_emp_no,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((schema.value.to_emp_no) = $event)),
                  filterable: "",
                  options: _unref(state).userList,
                  placeholder: "请选择接收用户工号",
                  loading: _unref(state).loadUsers,
                  disabled: _unref(state).loadUsers
                }, null, 8, ["modelValue", "options", "loading", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "移交原因",
              prop: "remark"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: schema.value.remark,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((schema.value.remark) = $event)),
                  type: "textarea",
                  "show-word-limit": "",
                  rows: "5",
                  maxlength: "150",
                  placeholder: "请输入移交原因"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])), [
        [_directive_loading, _unref(state).loading]
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})